import cloneDeep from 'lodash.clonedeep'
import getQueryParameter from '../../helpers/getQueryParameter'
import removeQueryParamFromUri from '../../helpers/removeQueryParamFromUri'

import {
  UPDATE_STORE_LOCATOR,
  UPDATE_ALTERNATIVE_STORE,
  UPDATE_CIS_COOKIE_STATUS
} from '../../actionTypes/storeLocatorActionTypes'

const buildInitalState = () => {
  const newState = {
    data: {},
    meta: {
      initialised: false
    }
  }
  newState.data.storeList = []
  newState.data.isLoading = false
  newState.data.isFinished = false
  newState.data.errorMessage = false
  newState.data.collectionMessaging = false
  newState.data.collectionLoading = false
  newState.data.currentSearchTerm = ''
  newState.data.didYouKnowMsg = false
  newState.data.deliveryPricing = []
  newState.data.deliveryPostcode = ''
  newState.data.storeNumber = ''
  newState.data.storeSelectorOpen = false
  newState.data.alternativeStoreSelected = false
  newState.data.deliveryMessage = false
  newState.data.deliveryLoading = false
  newState.data.deliveryError = false
  newState.data.stockCheckAvailable = true
  newState.data.cisCookieStatus = false
  newState.data.isLocalised = false
  newState.data.localityList = []
  if (global.window) {
    newState.data.storeNumber = getQueryParameter('storeID')
    if (newState.data.storeNumber) {
      newState.data.currentSearchTerm = newState.data.storeNumber
      removeQueryParamFromUri('storeID')
    }
  } else {
    newState.data.currentSearchTerm = ''
  }

  newState.meta.initialised = true
  return newState
}

const initialState = buildInitalState()

const updateStoreLocator = (oldState, payload) => {
  const newState = cloneDeep(oldState)
  newState.data = { ...newState.data, ...payload }
  return newState
}

const updateAlternativeStore = (oldState, payload) => {
  const newState = {
    ...oldState,
    data: {
      ...oldState.data,
      alternativeStore: payload
    }
  }
  return newState
}

const updateCisCookieStatus = (oldState, payload) => {
  const newState = {
    ...oldState,
    data: {
      ...oldState.data,
      cisCookieStatus: payload
    }
  }

  return newState
}

const storeLocatorReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_STORE_LOCATOR:
      return updateStoreLocator(state, payload)
    case UPDATE_ALTERNATIVE_STORE:
      return updateAlternativeStore(state, payload)
    case UPDATE_CIS_COOKIE_STATUS:
      return updateCisCookieStatus(state, payload)
    default:
      return state
  }
}

export { initialState, storeLocatorReducer }
